import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NoteRepository} from '../../repositories/note.repository';
import {PostPayloadInterface} from '../../models/post-payload.interface';
import {NotificationService} from '../../services/notification.service';

@Component({
  selector: 'app-reservation-note',
  templateUrl: './reservation-note.component.html',
  styleUrls: ['./reservation-note.component.scss']
})
export class ReservationNoteComponent implements OnInit {

  @Input() reservation: any;

  public focusTouched;
  public messageForm: FormGroup;
  public type = false;

  editNote: boolean = false;

  constructor(private noteRepository: NoteRepository,
              private notificationService: NotificationService,
              public formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.messageForm = this.formBuilder.group(
      {
        message: ['', [Validators.required, Validators.minLength(0)]],
        noteType: ['SIMPLE_MESSAGE', [Validators.required]]
      });
    if (this.reservation.notes.length > 0) {
      this.messageForm.get('message').setValue(this.reservation.notes[this.reservation.notes.length - 1].message);
    }
  }

  addNote() {
    if (!this.messageForm.get('message').valid) {
      return false;
    }
    const payload: PostPayloadInterface = {
      id: this.reservation.id,
      type: 'AddNote',
      attribute: {
        message: this.messageForm.get('message').value,
        type: 'SIMPLE_MESSAGE',
        entityId: this.reservation.id
      }
    };
    this.noteRepository.saveNote('reservations', payload).subscribe(data => {
      // this.notificationService.showSuccess('general.success');
      this.setEdit();
      this.reservation.notes.push(data);
    });
  }

  get messageF() {
    return this.messageForm.controls;
  }

  setEdit() {
    this.editNote = !this.editNote;
  }

}
